import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import {
  createGroupingData,
  createSubGroupingData,
  setSelectedItem,
  setViewType,
} from "@/features/bughurd/slice";
import {
  selectActiveSprintIds,
  selectApiData,
  selectGroupingConfig,
} from "@/features/bughurd/boardSelector";
import { useBoardFilters } from "./useBoardFilters";
import { useLocation } from "react-router-dom";

export const useBoardInitialization = (id?: string) => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const apiData = useAppSelector(selectApiData);
  const groupingConfig = useAppSelector(selectGroupingConfig);
  const { createFiltersObject, shouldApplyFiltersForGroupBy } =
    useBoardFilters();
  const { currentUser } = useAppSelector((state) => state.appGlobal);
  const activeSprintIds = useAppSelector(selectActiveSprintIds);

  const isMyTaskView = pathname.includes("/defect-tracker/my-tasks");

  // Update Redux store when API data changes
  useEffect(() => {
    const { statusList, companyMemberData, tagList } = apiData;

    const { groupBy, subGroupBy } = groupingConfig;

    // Create grouping data when dependencies change
    if (statusList || companyMemberData || tagList) {
      const filters = createFiltersObject(groupBy);
      const shouldApplyFilters = shouldApplyFiltersForGroupBy(groupBy);

      dispatch(
        createGroupingData({
          groupBy,
          statusList: statusList || [],
          companyMemberData: companyMemberData || [],
          tagList: tagList || [],
          ...(shouldApplyFilters && { filters }),
        })
      );
    }

    // Create sub-grouping data when dependencies change
    if (subGroupBy !== "None" && (statusList || companyMemberData || tagList)) {
      const filters = createFiltersObject(subGroupBy);
      const shouldApplyFilters = shouldApplyFiltersForGroupBy(subGroupBy);

      dispatch(
        createSubGroupingData({
          subGroupBy,
          statusList: statusList || [],
          companyMemberData: companyMemberData || [],
          tagList: tagList || [],
          ...(shouldApplyFilters && { filters }),
        })
      );
    }
  }, [
    apiData.statusList,
    apiData.companyMemberData,
    apiData.tagList,
    groupingConfig.groupBy,
    groupingConfig.subGroupBy,
    createFiltersObject,
    shouldApplyFiltersForGroupBy,
    activeSprintIds,
  ]);

  // const updateApiData = (data: any, type: string) => {
  //   switch (type) {
  //     case "statusList":
  //       if (data?.data?.decryptedData?.items) {
  //         dispatch(setStatusList(data.data.decryptedData.items));
  //       }
  //       break;
  //     case "projectDetails":
  //       if (data) {
  //         dispatch(setProjectDetails(data));
  //       }
  //       break;
  //     case "projects":
  //       if (data?.data?.decryptedData?.items) {
  //         dispatch(setProjects(data.data.decryptedData.items));
  //       }
  //       break;
  //     case "listOfBugs":
  //       if (data?.data?.decryptedData?.items) {
  //         dispatch(setListOfBugs(data.data.decryptedData.items));
  //         dispatch(setListCount(data.data.decryptedData.total || 0));
  //       }
  //       break;
  //     case "tagList":
  //       if (data?.data?.decryptedData?.items) {
  //         dispatch(setTagList(data.data.decryptedData.items));
  //       }
  //       break;
  //     case "companyMembers":
  //       if (data?.data?.decryptedData?.items) {
  //         dispatch(setCompanyMemberData(data.data.decryptedData.items));
  //       }
  //       break;
  //     case "isBugsLoading":
  //       dispatch(setIsBugsLoading(data));
  //       break;
  //     case "isBugsFetching":
  //       dispatch(setIsBugsFetching(data));
  //       break;
  //   }
  // };
  useEffect(() => {
    if (pathname.includes("/defect-tracker/my-tasks")) {
      dispatch(setSelectedItem("My Tasks"));
      dispatch(setViewType("kanban"));
    }
  }, [pathname]);
  return {
    isMyTaskView,
    // updateApiData,
    ...apiData,
    currentUser,
  };
};
